module.exports = __webpack_public_path__ + "static/media/phone.eca77e8d.png";